// Tema claro/oscuro. Sin elección guardada se sigue el del dispositivo ("system").
// public/index.html aplica la clase antes de cargar React (mismo criterio) para que no parpadee.
import { useEffect, useState } from 'react';

export const THEME_KEY = 'chainscout-theme'; // 'light' | 'dark'; sin valor = 'system'
export const THEME_CHANGE = 'chainscout-themechange';
const DARK_QUERY = '(prefers-color-scheme: dark)';

export const getThemePref = () => {
  try { return localStorage.getItem(THEME_KEY) || 'system'; } catch { return 'system'; }
};

const systemIsDark = () => Boolean(window.matchMedia?.(DARK_QUERY).matches);
export const isDarkFor = (pref) => pref === 'dark' || (pref === 'system' && systemIsDark());

export const applyTheme = (pref = getThemePref()) =>
  document.documentElement.classList.toggle('dark', isDarkFor(pref));

export const setThemePref = (pref) => {
  try {
    if (pref === 'system') localStorage.removeItem(THEME_KEY);
    else localStorage.setItem(THEME_KEY, pref);
  } catch { /* modo privado: vale para esta visita */ }
  applyTheme(pref);
  window.dispatchEvent(new Event(THEME_CHANGE));
};

/** { pref, isDark, setPref }; se actualiza si cambia el tema del dispositivo o desde otro componente */
export const useTheme = () => {
  const [pref, setPrefState] = useState(getThemePref);
  const [isDark, setIsDark] = useState(() => document.documentElement.classList.contains('dark'));

  useEffect(() => {
    const sync = () => {
      const p = getThemePref();
      applyTheme(p);
      setPrefState(p);
      setIsDark(isDarkFor(p));
    };
    const mq = window.matchMedia?.(DARK_QUERY);
    window.addEventListener(THEME_CHANGE, sync);
    mq?.addEventListener?.('change', sync);
    sync();
    return () => {
      window.removeEventListener(THEME_CHANGE, sync);
      mq?.removeEventListener?.('change', sync);
    };
  }, []);

  return { pref, isDark, setPref: setThemePref };
};
